<article>
  <header class="article-header">
    @if (navItems(); as navItems) {
      <nav
        mat-tab-nav-bar
        class="secondary-nav"
        [disablePagination]="false"
        [tabPanel]="tabPanel">
        @for (item of navItems.subItems; track item.label) {
          @if (item.subItems && item.subItems.length) {
            <button
              matButton
              class="menu-button"
              [matMenuTriggerFor]="submenu.menu()">
              <span class="flex align-center">
                <span class="menu-label">{{ item.name }}</span>
                <mat-icon>expand_more</mat-icon>
              </span>
            </button>
            <ume-main-nav-menu-panel
              #submenu
              [items]="item.subItems"></ume-main-nav-menu-panel>
          } @else {
            <a
              #rla="routerLinkActive"
              mat-tab-link
              routerLinkActive="link_active"
              [target]="item.target || '_self'"
              [routerLink]="item.link | companyTypeBasedRoute"
              [class.disabled]="item.disabled || item.payment"
              [active]="rla.isActive"
              (click)="handleClick(item, $event)">
              {{ item.name }}
            </a>
          }
        }
      </nav>
    }

    <div class="actions">
      <ng-container [ngTemplateOutlet]="actions"></ng-container>
    </div>
  </header>

  <main>
    <div class="content">
      <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </div>
  </main>
</article>
